import React from "react";
import DeliveryLogs from "./DeliveryLogs";
import MeetingService from "../../../services/MeetingService";

const WhatsappLogs = () => (
  <DeliveryLogs
    title="WhatsApp Logs"
    getLogs={MeetingService.getWhatsappLogs}
    getReport={MeetingService.getWhatsappLogReport}
  />
);

export default WhatsappLogs;
